import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import IRASService from "../../services/IRASService";

const initialState = {
    aisSummary: {},
    submittedRecords:{},
    submissionLogs: {},
    status: 'idle',
}

export const fetchAISSummary = createAsyncThunk('aisSummary', async (paramter) => {
    const response = await IRASService.getAISSubmissionSummary(paramter);
    return response;
});

export const fetchSubmittedRecords = createAsyncThunk('submitted-records', async (paramter) => {
    const response = await IRASService.getAISSubmittedDetailsData(paramter);
    return response;
});

export const fetchSubmissionLogs = createAsyncThunk('submission-logs', async (paramter) => {
    const response = await IRASService.getAISSubmissionLogs(paramter);
    return response;
});

export const AISSubmissionSlice = createSlice({
    name: "aisSubmission",
    initialState,
    reducers:{},
    extraReducers: (builder) => {
        builder
            .addCase(fetchAISSummary.pending, (state) => {
                state.status = "loading";
            })
            .addCase(fetchAISSummary.fulfilled, (state, action) => {
                state.status = "idle";
                state.aisSummary = action.payload;
            })
            .addCase(fetchSubmittedRecords.pending, (state) => {
                state.status = "loading";
            })
            .addCase(fetchSubmittedRecords.fulfilled, (state, action) => {
                state.status = "idle";
                state.submittedRecords = action.payload;
            }).addCase(fetchSubmissionLogs.pending, (state) => {
                state.status = "loading";
            })
            .addCase(fetchSubmissionLogs.fulfilled, (state, action) => {
                state.status = "idle";
                state.submissionLogs = action.payload;
            });
    }
})

export const selectAISSummary = (state) => {
    return state.aisSubmission.aisSummary
}

export const selectSubmittedRecords = (state) => {
    return state.aisSubmission.submittedRecords
}

export const selectSubmissionLogs = (state) => {
    return state.aisSubmission.submissionLogs
}

export default AISSubmissionSlice.reducer;